export default {
	btnCancel: 'Annuler',
	btnConfirm: 'Confirmer'
};
